
import React from 'react'
import useStyles from '../../assets/styles/style';
import { Paper, Box } from '@mui/material';
import ReviewForm, { StageDataProps } from './reviewForm';
import ReviewFormHeading from './reviewFormHeading';
import { useParams } from 'react-router-dom';

const ReviewMain = () => {
    const classes = useStyles();
    const {id} = useParams();

    return (
        <div className={classes.formMainContainer}>
            <Box className={classes.formMainHeadingBox}>
                <ReviewFormHeading />
            </Box>
            <Box component="main" className={classes.formMainBox}>
                <Paper className={classes.formMainpaper}>
                    <ReviewForm projectId= {id || ''} stageData={{} as StageDataProps} />
                </Paper>
            </Box>
        </div>
    );
}

export default ReviewMain